import { supabase } from '../supabase';

const BUCKET = 'driver-licenses';
const MAX_BYTES = 5 * 1024 * 1024;
const ALLOWED = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];

/**
 * Upload a driver licence file and persist the storage path on the profile.
 * @param {string} userId
 * @param {File} file
 */
export async function uploadDriverLicense(userId, file) {
  if (!file) return { path: null, error: { message: 'Choose a file first.' } };
  if (!ALLOWED.includes(file.type)) {
    return { path: null, error: { message: 'Use JPG, PNG, WebP, or PDF.' } };
  }
  if (file.size > MAX_BYTES) {
    return { path: null, error: { message: 'File must be 5 MB or smaller.' } };
  }

  const ext = file.name.split('.').pop()?.toLowerCase() || 'bin';
  const path = `${userId}/licence-${Date.now()}.${ext}`;

  const { error: uploadErr } = await supabase.storage.from(BUCKET).upload(path, file, {
    upsert: true,
    contentType: file.type,
  });
  if (uploadErr) return { path: null, error: uploadErr };

  const { error: rpcErr } = await supabase.rpc('set_driver_license_file', { p_path: path });
  if (rpcErr) return { path: null, error: rpcErr };

  return { path, error: null };
}

/** Signed URL for admin or driver to view a licence file. */
export async function getDriverLicenseUrl(path) {
  if (!path) return { url: null, error: null };
  const { data, error } = await supabase.storage.from(BUCKET).createSignedUrl(path, 3600);
  return { url: data?.signedUrl || null, error };
}
